import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './HomePage.css';
import { LanguageContext } from '../App';
import { FIRM_INFO } from '../constants/firmInfo';
import { useAuth } from '../context/AuthContext';
import { handleProtectedNavigation } from '../utils/navigation';
import { translations } from '../utils/translations';

function HomePage() {
  const navigate = useNavigate();
  const { language } = useContext(LanguageContext);
  const t = translations[language] || translations.en;
  const homeContent = t.homepage || t.home;
  const { user, intakeComplete } = useAuth();

  const handleBlogClick = () => {
    window.open('https://cohentuckerlaw.com/blog', '_blank', 'noopener,noreferrer');
  };

  const handleEmergencyCall = () => {
    window.location.href = `tel:${FIRM_INFO.phone}`;
  };

  const handleContactAttorneyClick = () => {
    if (!user) {
      navigate('/intake?redirect=contact&guest=true');
      return;
    }

    if (!intakeComplete) {
      navigate('/intake?redirect=contact');
      return;
    }

    navigate('/contact-flow');
  };

  return (
    <div className="page-container">
      <div className="page-content">
        <section className="hero">
          <h1 className="hero-title">{homeContent.heroTitle}</h1>
          <p className="hero-subtitle">{homeContent.heroSubtitle || homeContent.heroSub}</p>
          <div className="hero-buttons">
            <button
              className="btn btn-primary btn-large"
              onClick={() =>
                handleProtectedNavigation({
                  user,
                  intakeComplete,
                  navigate,
                  target: '/dashboard',
                })
              }
            >
              {homeContent.primaryButton || t.buttons.getHelp}
            </button>
            <button className="btn btn-secondary btn-large" onClick={handleEmergencyCall}>
              {homeContent.emergencyButton || t.buttons.callNow}
            </button>
          </div>
        </section>

        <section className="how-it-works">
          <h2>{homeContent.howItWorksTitle || homeContent.howTitle}</h2>
          <div className="cards-grid">
            <button
              className="info-card info-card-button"
              onClick={() =>
                handleProtectedNavigation({
                  user,
                  intakeComplete,
                  navigate,
                  target: '/dashboard',
                })
              }
            >
              <div className="card-icon">📚</div>
              <h3>{homeContent.cards?.understandRights?.title || t.home.card1Title}</h3>
              <p>{homeContent.cards?.understandRights?.body || t.home.card1Desc}</p>
              <span className="card-arrow">→</span>
            </button>

            <button
              className="info-card info-card-button"
              onClick={() =>
                handleProtectedNavigation({
                  user,
                  intakeComplete,
                  navigate,
                  target: '/dashboard',
                })
              }
            >
              <div className="card-icon">⚡</div>
              <h3>{homeContent.cards?.immediateGuidance?.title || t.home.card2Title}</h3>
              <p>{homeContent.cards?.immediateGuidance?.body || t.home.card2Desc}</p>
              <span className="card-arrow">→</span>
            </button>

            <button
              className="info-card info-card-button"
              onClick={handleContactAttorneyClick}
            >
              <div className="card-icon">📞</div>
              <h3>{homeContent.cards?.contactAttorney?.title || t.home.card3Title}</h3>
              <p>{homeContent.cards?.contactAttorney?.body || t.home.card3Desc}</p>
              <span className="card-arrow">→</span>
            </button>
          </div>
        </section>

        <section className="trust-section">
          <div className="trust-content">
            <h2>{homeContent.trustTitle}</h2>
            <p className="trust-text">{homeContent.trustText}</p>
          </div>
        </section>

        <section className="learn-more-section">
          <h3>{homeContent.learnMoreTitle || t.home.infoTitle}</h3>
          <p>{homeContent.learnMoreBody || t.home.infoDesc}</p>
          <button className="btn btn-outline" onClick={handleBlogClick}>
            {homeContent.learnMoreButton || t.home.learnMore}
          </button>
        </section>

        <section className="firm-footer">
          <h3>{FIRM_INFO.name}</h3>
          <p>📞 {FIRM_INFO.displayPhone}</p>
          <p>📧 {FIRM_INFO.email}</p>
          <p>📍 {FIRM_INFO.address}</p>
          <div className="footer-links">
            <Link to="/terms" className="footer-link">
              {t.legal.termsOfUse}
            </Link>
            <Link to="/privacy" className="footer-link">
              {t.legal.privacyPolicy}
            </Link>
          </div>
          <p className="legal-disclaimer">{t.legal.attorneyAdvertising}</p>
          <p className="legal-privacy-note">{t.legal.noTracking}</p>
        </section>
      </div>
    </div>
  );
}

export default HomePage;
